// extracted by mini-css-extract-plugin
export default {"table":"ActionsHistry_table__jBsVj","tableHead":"ActionsHistry_tableHead__EDiCs","noData":"ActionsHistry_noData__R-O35"};